/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * MessJob model representing a measurement job
 */
export type MessJobEntity = {
    id?: (string | null);
    /**
     * MessJob name
     */
    name: string;
    /**
     * MessJob type (default|project)
     */
    type: MessJobEntity.type;
    /**
     * Associated MessProject ID
     */
    messproject_id: string;
    /**
     * Creation mode of the MessJob (simple|incremental|rollating)
     */
    creation_mode?: MessJobEntity.creation_mode;
    /**
     * Status of the MessJob (pending, running, completed, failed)
     */
    status?: string;
    /**
     * Creator name
     */
    creator_name?: string;
    /**
     * Timestamp of creation
     */
    created_at_dttm?: string;
    /**
     * Timestamp of the last modification
     */
    last_modified_dttm?: string;
    /**
     * Name of the last modifier
     */
    last_modifier_name?: (string | null);
};
export namespace MessJobEntity {
    /**
     * MessJob type (default|project)
     */
    export enum type {
        DEFAULT = 'default',
        PROJECT = 'project',
    }
    /**
     * Creation mode of the MessJob (simple|incremental|rollating)
     */
    export enum creation_mode {
        SIMPLE = 'simple',
        INCREMENTAL = 'incremental',
        ROLLATING = 'rollating',
    }
}

